import React, { Component } from 'react';
import styled from 'styled-components';
import deleteIcon from '../../components/atoms/data/delete-icon.svg';
import recordIcon from '../../components/atoms/data/record-list-icon.svg';
import sendIcon from '../../components/atoms/data/send-icon.svg';
import sentIcon from '../../components/atoms/data/sent-icon.svg';


/*
props:
 onClickNext: callback function
*/
const RecResult = (props) => {
    const [play,setPlay] =  React.useState(false); // 再生ステータス
    const onClickPlay = () => {
        if(!play) {
            // 再生処理呼び出し
            props.onClickPlay(0, true, () => {
                // 再生終了時処理
                setPlay(false);
            });

            // 再生ステータスをONに変更
            setPlay(true);
        } else {
            // 停止処理呼び出し
            props.onClickPlay(0, false);
            // 全ての行のステータスをOFFに更新
            setPlay(false);
        }
    } 
    let message;
    let color;
    let playFunc;
    let saveFunc;
    let deleteFunc;
    let sendFunc;
    let sentFunc;
    if (props.prepare) {
        color = "#0077FF";
        saveFunc = props.onClickSave;
        deleteFunc = props.onClickDelete;
        sendFunc = props.onClickSend;
        sentFunc = props.onClickSent;
        message = "録音した音声を確認できます";
    } else {
        color = "#777777";
        message = "録音データを処理しています";
    }
    return (
        <Top>
            <div style={{ fontSize: '14px' }}>
                {message}
            </div>
            <RecIcon Color={color} onClick={onClickPlay}>
                {play ? <i className="fas fa-equals fa-rotate-90 fa-2x" style={{ width: "24px"}} /> : <i className="far fa-play-circle fa-2x" />}
            </RecIcon>
            <Control>
                <IconWrap>
                    <Icon Width="65px" onClick={saveFunc}>
                        <img src={recordIcon} alt="img" width="30px" height="30px" />
                    </Icon>
                    <RecMsg2>
                        録音リストに<br />保存する
                    </RecMsg2>
                </IconWrap>
                <IconWrap>
                    <Icon Width="65px" onClick={sendFunc}>
                        <img src={sendIcon} alt="img" width="30px" height="30px" />
                    </Icon>
                    <RecMsg1>
                        送信する
                    </RecMsg1>
                </IconWrap>
                <IconWrap>
                    <Icon Width="65px" onClick={deleteFunc}>
                        <img src={deleteIcon} alt="img" width="30px" height="30px" />
                    </Icon>
                    <RecMsg1>
                        削除する
                    </RecMsg1>
                </IconWrap>
            </Control>
        </Top>
    )
}
const HistoryCheck = (props) => {
    return (
        <div>
            <div style={{ fontSize: '14px' }}>
                保存した音声を確認できます
            </div>
        </div>
    );
}
const HistoryList = (props) => {
    const [plays,setPlays] =  React.useState({}); // 再生ステータス
    let ret = [];
    let i = 0;

    // 初期表示時
    React.useEffect(() => {
        offAllPlays();
    }, []);

    // 再生ステータスを全てOFF
    const offAllPlays = () => {
        const temp = {};
        for(let i = 0; i < props.records.length; i++){
            temp[i] = false;
        }
        setPlays(temp);
        return temp;
    }

    const onClickPlay = (index) => {
        if(!plays[index]) {
            // 再生処理呼び出し
            props.onClickPlay(index+1, true, () => {
                // 再生終了時処理
                offAllPlays();
            });

            // 該当indexのステータスをONに変更
            const temp = offAllPlays(); // 1度、全てOFFに更新(他の行を再生中の場合を考慮して)
            temp[index] = true;
            setPlays(temp);
        } else {
            // 停止処理呼び出し
            props.onClickPlay(index+1, false);
        }
    } 
    
    for (let key in props.records) {
        const index = i;
        if (props.records[key]) {
            ret.push(
                <History key={key}>
                    <RecIcon Color="#0077FF" onClick={e => onClickPlay(index)}>
                        {plays[index] ? <i className="fas fa-equals fa-rotate-90" style={{ width: "12px"}} /> : <i className="far fa-play-circle" />}
                    </RecIcon>
                    <div>
                        {props.records[key].createDate}
                        　の録音
                    </div>
                        {props.records[key].submitFlg == 0 && <Icon onClick={e => props.onClickSend(index + 1)}><img src={sendIcon} alt="img" width="36px" height="30px" /></Icon>}
                        {props.records[key].submitFlg == 1 && <Icon onClick={e => props.onClickSent(index + 1)}><img src={sentIcon} alt="img" width="36px" height="30px" /></Icon>}
                    <Icon onClick={e => props.onClickDelete(index + 1)}>
                        <img src={deleteIcon} alt="img" width="30px" height="30px" />
                    </Icon>
                </History>
            )
        }
        i++;
    }

    return (
        <Histories>
            {ret}
        </Histories>
    );
}

class RecFinish extends Component {
    constructor(props) {
        super(props);

        this.maxHistory = 3;
        this.state = {
        }
    }
    render() {
        let top;
        let list;

        if (this.props.notRecording) {
            top = (
                <HistoryCheck />
            );
            list = (
                <HistoryList
                    records={this.props.records}
                    onClickPlay={this.props.onClickPlay}
                    onClickSend={this.props.onClickSend}
                    onClickSent={this.props.onClickSent}
                    onClickDelete={this.props.onClickDelete}
                />
            );
        } else {
            top = (
                <RecResult
                    prepare={this.props.prepare}
                    onClickPlay={this.props.onClickPlay}
                    onClickSave={e => this.props.onClickSave(0)}
                    onClickSend={e => this.props.onClickSend(0)}
                    onClickSent={e => this.props.onClickSent(0)}
                    onClickDelete={e => this.props.onClickDelete(0)}
                />
            );
            list = ("");
        }
        return (
            <Body name="rec-finish" Display={this.props.display}>
                <Menu Display={this.props.display}>
                    {top}
                    {list}
                    <BackButton onClick={this.props.onClickBack}>
                        <i className="fas fa-times fa-sm"/>
                    </BackButton>
                </Menu>
            </Body>
        );
    }
}

export { RecFinish };

const Body = styled.div`
    position: absolute;
    width: 100%;
    height: 30%;
    top: 70%;
    left: 0;
    opacity: ${props => (props.Display ? '1' : '0')};
    transition-duration: 0.2s;
    pointer-events: ${props => (props.Display ? '' : 'none')};

    text-align: center;
`;

const Menu = styled.div`
    position: absolute;
    bottom: ${props => (props.Display ? '0%' : '-100%')};
    left: 0;
    height: 109px;
    border-top: 1px solid #888;

    background-color: #fff;
    transition-duration: 0.2s;
    width: 100%;

`;

const Top = styled.div`
    display: flex;
    flex-direction: column;
    height: 110px;

`;

const IconWrap = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 75px;
`;
const Icon = styled.div`
    color: ${props => (props.Color)};
    width: ${props => (props.Width ? props.Width : "auto")};
    transition-duration: 0.2s;
`;

const RecMsg2 = styled.div`
    height: 30px;
    line-height: 15px;
`;
const RecMsg1 = styled.div`
    height: 30px;
    line-height: 30px;
`;

const RecIcon = styled.div`
    color: ${props => (props.Color)};
    width: ${props => (props.Width ? props.Width : "auto")};
    transition-duration: 0.2s;
`;

const Control = styled.div`
    display: flex;
    justify-content: space-evenly;
    align-items: center;
`;
const Histories = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
`;
const History = styled.div`
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    width: 100%;
    font-size: 12px;
    margin-bottom: -5px;
`;

const BackButton = styled.div`
    position: absolute;
    top: -5px;
    right: 10px;
    width: 32px;
    height: 32px;
    color: #00b050;
    font-size: 24px;
`;
